import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { WorkflowInputFilter } from "domain/models/workflow-input-filter";
import workflowRepository from "infra/repositories/workflow-repository";
import { Logger } from "../../infra/logger/logger";

export const useWorkflowByFilter = (filter: WorkflowInputFilter) => {
  const logger = Logger.getInstance();

  return useQuery({
    queryKey: ["workflows", filter],
    queryFn: async () => {
      try {
        const result = await workflowRepository.getAllToApproval(filter);
        return result;
      } catch (error: any) {
        console.log(error);
        if (error instanceof AxiosError) {
          logger.error(
            error.response?.data.metadata.errors[0],
            error.response?.data.metadata
          );
          throw new Error(error.response?.data.metadata.errors);
        }
        throw error;
      }
    },
    retry: Number(process.env.REACT_APP_QUERY_RETRY) || 5,
    staleTime: 0,
    enabled: !!filter?.employeeId,
  });
};
